<template>
                       
        <div>
            <v-text-field
                @click:clear="clearDate()"
                @click="showModal()"
                v-model="date"
                :label="label"
                prepend-icon="event"
                readonly
                clearable
                
            ></v-text-field>
            <v-dialog v-model="showDatePicker" max-width max-width="290px">   
                <i @click="showDatePicker=false" class="close-cross fas fa-times"></i>
                <v-date-picker v-model="date" @input="emitValue()" locale="nl-nl"></v-date-picker>    
            </v-dialog> 
        </div>
</template>

<script>
    export default {
        props:["label","value"],        
        data(){
            return {                
                showDatePicker:false,
                menu:false,   
                date:new Date().toISOString().substr(0, 10),               
            }
        },
        methods: {
            emitValue() {
                this.showDatePicker=false;
                this.$emit('input', this.date)
            },
            showModal(){
                this.showDatePicker=true;
            },
            clearDate(){
                this.$emit('input', null)                
            }
        },
        watch: {
            'value': {
                handler:function(newValue){                    
                    this.date = newValue;                    
                },
                deep:true
            }
        },                
        created(){   
            if(this.value){
                this.date = this.value
            }
        },
        mounted(){            
            this.emitValue()
        }
    }
</script>

<style scoped>
    .close-cross{
        cursor: pointer;
        position:absolute;
        margin-left:270px;
        z-index: 2000;
        color:white;
        padding:4px;
    }
</style>